

















import { EvtEvent } from 'gl-ms-events';
import { TriTrip } from 'gl-ms-trips';

export default {
    data() {
        return {
        };
    },
    props: {
        triTrip: {
            type: Object,
        },
        currentEvent: {
            type: Object,
        },
    },
    computed: {
        getEventAddress(this: any) {
            return [this.currentEvent.address.ragione_sociale, this.currentEvent.address.indirizzo, this.currentEvent.address.cap, this.currentEvent.address.provincia, this.currentEvent.address.zona, this.currentEvent.address.nazione].filter(part => Boolean(part)).join(', ');
        },
        getTruckTrailerPlate(this: any) {
            return [this.triTrip.truck.plate, this.triTrip.trailer.plate].filter(part => Boolean(part)).join('/');
        },
    },
};
